module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 133
// module chunks = 0